import { Button } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import classNames from 'classnames';
import { useEffect, useMemo, useState } from 'react';

import { useTranslation } from '@/i18n/client';
import { saveIntroduction } from '@/service/visualization';
import useBiogStore from '@/store/useBiogStore';

interface IProps {
  className?: string;
}

function AboutMe(props: IProps): JSX.Element {
  const { className } = props;
  const introduce = useBiogStore((state) => state.introduce);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isCancelLoading, setIsCancelLoading] = useState<boolean>(false);
  const updateAboutMe = useBiogStore((state) => state.updateAboutMe);
  const aboutMe = useBiogStore((state) => state.aboutMe);
  const { t } = useTranslation();

  const hintStr = useMemo(() => {
    return `${introduce.userName ?? t('bio.hi')}, ${t('bio.introducingYourself')}`;
  }, [introduce]);

  useEffect(() => {
    updateAboutMe();
  }, []);

  const handleSaveAboutMe = () => {
    setIsLoading(true);

    setTimeout(() => {
      // 防止about me 还没更新
      saveIntroduction({ selfIntroduction: aboutMe }).catch((e) => {
        console.error(e);
      });
    }, 50);
    setIsLoading(false);
    setIsEdit(false);
  };

  return (
    <div
      className={classNames(
        'box-border w-full px-4 py-3 flex flex-col justify-center gap-2 bg-[rgba(254,253,255,0.5)] rounded-[24px]',
        className
      )}
    >
      <div className="flex justify-between">
        <div className="font-medium text-[14px] leading-6 text-[#756C5D]">{t('bio.aboutMe')}</div>
        {isEdit ? (
          <div className="flex gap-3 items-center">
            <Button
              className="w-[43px] h-[24px] px-2 py-[2px] rounded-[18px] text-[#756C5D] flex items-center justify-center border-none bg-transparent outline-none shadow-none"
              loading={isCancelLoading}
              onClick={() => {
                setIsCancelLoading(true);
                updateAboutMe();
                setIsCancelLoading(false);
                setIsEdit(false);
              }}
            >
              {t('common.cancel')}
            </Button>
            <Button
              className="h-[24px] border-none px-2 py-[2px] text-xs leading-5 rounded-[18px] !text-[#FEFDFF] flex items-center justify-center bg-[#7B67EF]"
              disabled={!aboutMe}
              loading={isLoading}
              onClick={handleSaveAboutMe}
            >
              {t('common.save')}
            </Button>
          </div>
        ) : // (
        //   <div
        //     className="w-6 h-6 flex items-center justify-center bg-[rgba(254,253,255,0.3)] p-[6px] text-[#756C5D] text-[12px] rounded-full cursor-pointer transition-colors duration-200 hover:bg-[rgba(254,253,255,0.5)]"
        //     onClick={() => setIsEdit(true)}
        //   >
        //     <Icon component={EditorSvg} />
        //   </div>
        // )
        null}
      </div>
      {isEdit ? (
        <TextArea
          autoFocus
          autoSize={{ minRows: 1, maxRows: 4 }}
          className="!leading-6 !min-h-[48px] border-none bg-transparent p-0 outline-none focus:outline-none focus:shadow-none"
          defaultValue={aboutMe}
          onChange={(e) => updateAboutMe(e.target.value)}
          placeholder={hintStr}
          style={{ resize: 'none' }}
        />
      ) : aboutMe ? (
        <div className="leading-6 min-h-[48px]" onClick={() => setIsEdit(true)}>
          {aboutMe}
        </div>
      ) : (
        <div className="text-[#B8AD9B] min-h-[48px] leading-6" onClick={() => setIsEdit(true)}>
          {hintStr}
        </div>
      )}
    </div>
  );
}

export default AboutMe;
